import { createAsyncThunk } from '@reduxjs/toolkit';

import { AccountService } from 'api';
import { DownloadUserAgreementProps } from 'models/api';
import { downloadDocuments } from '../../../utils';

export const downloadUserAgreement = createAsyncThunk(
	'userSettings/downloadUserAgreement',

	(data: DownloadUserAgreementProps) =>
		downloadDocuments(data, data.fileName, AccountService.downloadAgreement),
);
